import * as React from 'react'
import { IErrorState } from "../reducers/appReducers"
import { useSelector } from 'react-redux'
import DOMPurify from "dompurify";
import * as AppTypes from "AppTypes"
import PrimaryButton from '../components/PrimaryButton'
import { updateLanguageAATagging, updateAATagging } from '../utils/aatagging'

const Error: React.FC = () => {

    const { viewState = {}, isCallingApi, langPack, userInfo } = useSelector((store: AppTypes.ReducerState) => ({
        viewState: store.app.viewState as IErrorState,
        isCallingApi: store.app.isCallingApi,
        langPack: store.config.langPack,
        userInfo: store.userInfo
    }))
    const { title, content, button } = viewState

    React.useEffect(() => {
        // AA Tracking
        const AALang = updateLanguageAATagging(langPack["lang"])
        updateAATagging({
            "event_name": "generic_form_error",
            "form_name": "UOB PoY",
            "error_code": "",
            "language": AALang,
            "country": userInfo.activeCountry.toLowerCase()
        }, "other_form_error")
    })

    return (
        <React.Fragment>
            <div className="content">
                <h2 className="app-title">{title || langPack["labelError"]}</h2>
                {content
                    && <p
                        className="app-error-content"
                        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(content) }}
                    />
                }

            </div>
            {button && <div className="action">
                <PrimaryButton
                    text={button.text}
                    onClick={button.onClick}
                    disabled={isCallingApi}
                />
            </div>}
        </React.Fragment>
    )
}

export default Error